import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const FacebookServices: React.FC = () => <PlatformServicePage platform="facebook" />;
export default FacebookServices;
